import { notFound } from "@tanstack/react-router";
import { createMiddleware } from "@tanstack/react-start";
import { ApiError } from "#/modules/util.auth/api-errors";

/** A 404 from a GET server function (a loader) renders the nearest `notFoundComponent`. */
export const notFoundMiddleware = createMiddleware({ type: "function" }).server(
  async ({ next, method }) => {
    try {
      return await next();
    } catch (error) {
      if (method === "GET" && ApiError.is(error) && error.status === 404) {
        throw notFound();
      }
      throw error;
    }
  },
);
